import React, { useMemo } from 'react';
import { Select } from 'antd';
import _ from 'lodash';
import stringUtils from '@app/utils/string.utils';
import RequiredIcon from '@app/components/UI/Icons/RequiredIcon';
import PropTypes from 'prop-types';

const propTypes = {
    /** Tiêu đề */
    title: PropTypes.string,
    /** Danh sách dữ liệu hiển thị select */
    dataSource: PropTypes.arrayOf(PropTypes.shape({})),
    /** Giá trị select đang được chọn */
    selectId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.bool,
        PropTypes.array,
    ]),
    /** tên field của Id */
    idField: PropTypes.string,

    /** Tên field của tên hiển thị */
    nameField: PropTypes.string,

    onChange: PropTypes.func,
    onItemChange: PropTypes.func,
};

const ScSelectCustomBase = ({
    title,
    dataSource = [],
    selectId,
    idField,
    nameField,
    disabled,
    isMultiple,
    onItemChange,
    onChange,
    isRequired,
    ...props
}) => {
    const listOption = useMemo(() => {
        if (
            _.isEmpty(dataSource) ||
            stringUtils.isEmpty(nameField) ||
            stringUtils.isEmpty(idField)
        ) {
            return [];
        }

        return dataSource.map((o) => ({
            label: o[nameField],
            value: o[idField],
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataSource]);

    const handleChange = (value) => {
        onChange?.(value);
        onItemChange?.(list.find((o) => o[idField] === value) ?? {});
    };

    return (
        <>
            {!stringUtils.isEmpty(title) && (
                <label>
                    <h6 className="panel-title">
                        {title} {isRequired && <RequiredIcon />}
                    </h6>
                </label>
            )}
            <Select
                value={selectId}
                onChange={handleChange}
                options={listOption}
                disabled={disabled}
                className="disable-modified sc-select-box"
                mode={isMultiple ? 'multiple' : null}
                {...props}
            />
        </>
    );
};

ScSelectCustomBase.propTypes = propTypes;

export default ScSelectCustomBase;
